// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XDx-b","margin":"styles_margin__3qW-5"};